const ResumeApi = [
  {
    id: 1,
    category: "education",
    year: "Sri Sathya Sai Kiddies Abode,Burla (2014 - 2015)",
    title: "Secondary School",
    rate: "CGPA : 8.6",
  },
  {
    id: 2,
    category: "education",
    year: "Gurur Nanak Public School, Sambalpur (2017 - 2018) ",
    title: "Higher Secondary School",
    rate: "CGPA : 6.25",
  },
  {
    id: 3,
    category: "education",
    year: "Centurion University of Technology and Management(2018 - 2021) ",
    title: "Graduation",
    rate: "CGPA : 8.7",
  },
  {
    id: 4,
    category: "experience",
    year: "Chandigarh University (2021 - 2023) ",
    title: "Post Graduation",
    rate: "CGPA : 7.8 ",
  },
]

export default ResumeApi
